"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _emotion = require("@rebass/grid/emotion");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var SubHeadline = (
/*#__PURE__*/
0, _styledBase["default"])(_emotion.Flex, {
  target: "e15vn8n40",
  label: "SubHeadline"
})(process.env.NODE_ENV === "production" ? {
  name: "1jfvg9w",
  styles: "align-items:flex-start;"
} : {
  name: "1jfvg9w",
  styles: "align-items:flex-start;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21wb25lbnRzL3N1Yi1oZWFkbGluZS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHZ0MiLCJmaWxlIjoiLi4vLi4vc3JjL2NvbXBvbmVudHMvc3ViLWhlYWRsaW5lLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCI7XHJcbmltcG9ydCB7IEZsZXggfSBmcm9tIFwiQHJlYmFzcy9ncmlkL2Vtb3Rpb25cIjtcclxuXHJcbmNvbnN0IFN1YkhlYWRsaW5lID0gc3R5bGVkKEZsZXgpYFxyXG4gIGFsaWduLWl0ZW1zOiBmbGV4LXN0YXJ0O1xyXG5gO1xyXG5cclxuZXhwb3J0IGRlZmF1bHQgU3ViSGVhZGxpbmU7XHJcbiJdfQ== */"
});
var _default = SubHeadline;
exports["default"] = _default;